import { styled } from 'linaria/lib/react';
import React, { forwardRef } from 'react';
import Image from 'next/image';
import { theme } from '@mtsbank/ui-kit';
import messageDark from '@asserts/images/cyber/messageDark.png';
import { PaymentButton } from './buttons/PaymentButton';
interface CyberIndividualOrderProps {
  title: string;
  text1: string;
  text2: string;
  onClick: () => void;
}
export const CyberIndividualOrder = forwardRef<HTMLDivElement, CyberIndividualOrderProps>(({
  title,
  text1,
  text2,
  onClick
}, forwardRef) => <WrapperIndividualOrder id="individual-order" ref={forwardRef}>
      <WrapperText>
        <HeadingTitle>{title}</HeadingTitle>
        <div>
          <Text>{text1}</Text>
          <Text>{text2}</Text>
        </div>
        <WrapperButton>
          <PaymentButton title="ПОДРОБНЕЕ" type="button" height={44} onClick={onClick} />
        </WrapperButton>
      </WrapperText>
      <WrapperImage>
        <Image src={messageDark} alt="image" width={152} height={152} />
      </WrapperImage>
    </WrapperIndividualOrder>);
const WrapperIndividualOrder = /*#__PURE__*/styled("div")({
  name: "WrapperIndividualOrder",
  class: "wukkres"
});
const WrapperText = /*#__PURE__*/styled("div")({
  name: "WrapperText",
  class: "wflpuco"
});
const HeadingTitle = /*#__PURE__*/styled("div")({
  name: "HeadingTitle",
  class: "h991nk7"
});
const Text = /*#__PURE__*/styled("div")({
  name: "Text",
  class: "t1g1ppxk"
});
const WrapperImage = /*#__PURE__*/styled("div")({
  name: "WrapperImage",
  class: "wbziof2"
});
const WrapperButton = /*#__PURE__*/styled("div")({
  name: "WrapperButton",
  class: "ws7ybve"
});

require("./CyberIndividualOrder.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./CyberIndividualOrder.tsx");